import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Input, Button } from '@nazka/nazka.mapframe.components';

import Modal from '@App/components/Modal/Modal';
import { forgotPassword } from '@services/auth.service';

import ResetPassword from '../ResetPassword/ResetPassword';
import { isValidEmail } from '../login-modal.utils';

function ForgotPassword({ onClose, goBack }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState();

  const forgotPasswordMutation = useMutation({
    mutationFn: async () => {
      await forgotPassword(email);
    },
  });

  return (
    <Modal
      title="Wachtwoord vergeten"
      isOpen
      className="login-modal"
      closeOnOverlayClick={false}
      showCloseButton={!forgotPasswordMutation.isSuccess}
      onClose={onClose}
    >
      {forgotPasswordMutation.isSuccess
        ? <ResetPassword email={email} goBack={goBack} />
        : (
            <>
              <div className="login-modal__form">
                <label className={`login-modal__form__label${error ? ' login-modal__form__label--error' : ''}`}>
                  <span className="login-modal__form__label__text">
                    Emailadres
                  </span>
                  <Input
                    className="login-modal__form__label__input"
                    value={email}
                    onInputChange={v => setEmail(v?.target?.value)}
                  />
                </label>
                {
                  (!forgotPasswordMutation.isSuccess) && (error || forgotPasswordMutation.isError) && (
                    <p className="login-modal__form__label__error">
                      {error || 'Er ging iets mis.'}
                    </p>
                  )
                }
              </div>
              {!forgotPasswordMutation.isSuccess && (
                <Button
                  className="login-modal__submit-button"
                  onClick={() => {
                    if (!email || !email.length) {
                      setError('Emailadres is niet ingevuld.');
                    } else if (!isValidEmail(email)) {
                      setError('Ongeldig emailadres.');
                    } else {
                      forgotPasswordMutation.mutate();
                      setError(null);
                    }
                  }}
                  isLoading={forgotPasswordMutation.isPending}
                >
                  Verstuur email
                </Button>
              )}
            </>
          )}
    </Modal>
  );
}

export default ForgotPassword;
